<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<template>
  <div class="columns mt-4">
    <div class="column is-7">
      <div class="columns">
        <template
          v-for="(subCategories, mainCategory) in restructuredData"
          :key="mainCategory"
        >
          <div class="column is-6">
            <div class="h4 is-brightGreen">
              {{ mainCategory }}
            </div>
            <div
              v-for="(details, subCategoryKey) in subCategories"
              :key="subCategoryKey"
            >
              <p
                class="is-bold mb-0 mt-4"
                :class="{ 'is-blue': subCategoryKey === 'Wetland', 'is-darkGreen': subCategoryKey === 'Terrestrial' }"
              >
                {{ subCategoryKey }}
              </p>
              <div v-if="details.length > 0">
                <div
                  v-for="selected in details"
                  :key="selected"
                >
                  <p>{{ selected }}</p>
                </div>
              </div>
              <p
                v-else
                class="mt-2"
              >
                None Selected
              </p>
            <!-- <display-selection
                :label="subCategory.name"
                :data-list="subCategory.detail"
              /> -->
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="column is-5">
      <div class="h4 is-brightGreen">
        Filters
      </div>
      <display-selection
        :label="$t('rawdata.tabs.tab2.multipleVisitHeader')"
        :data-list="filterOptions.multipleVisit"
        :selected="mulitipleVisit"
      />

      <display-selection
        :label="$t('rawdata.tabs.tab2.onOffGridHeader')"
        :data-list="filterOptions.onOffGrid"
        :selected="onOffGrid"
      />

      <display-selection
        :label="$t('rawdata.tabs.tab2.rotationHeader')"
        :data-list="filterOptions.rotation"
        :selected="rotation"
      />
      <display-selection
        :label="selectedRegion?.name"
        :data-list="selectedRegion?.subregion"
      />
    </div>
  </div>
  <hr>
  <div class="text-right">
    <button
      v-if="!isDownloading"
      aria-label="Download"
      class="button is-brightGreen is-outlined"
      @click="downloadSelectedRawdata"
    >
      <label>Download</label>
    </button>
    <button
      v-else
      class="button disabled"
      aria-label="Download disabled"
    >
      <label>Downloading ...</label>
    </button>
    <div v-show="downloadLink.href">
      <p>{{ $t('rawdata.tabs.tab3.manualDownloadMsg') }}</p>
      <a
        ref="linkElement"
        class="download-button button"
        aria-label="Download"
        download
        target="_blank"
        :href="downloadLink.href"
      >
        Raw Data File({{ downloadLink.fileSize }})
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { ref } from 'vue';
import DisplaySelection from './DisplaySelection.vue';
// import { useI18n } from 'vue-i18n';
import { rawdataState } from '@/composables/state/rawdataApp';
import { RawdataDownloadParamType } from '@/config/rawdata';
import { ref, computed } from 'vue';
const {
  filterOptions,
  dataCategoryOptions,

  categories,
  rotation,
  onOffGrid,
  mulitipleVisit,
  regions,
  selectedRegion,
  downloadLink,
  downloadRawdata,
} = rawdataState();

const isDownloading = ref(false);

const linkElement = ref(null);
const downloadSelectedRawdata = () => {
  const param:RawdataDownloadParamType = {
    offgridId: onOffGrid.value,
    rawdata: categories.value,
    region: Object.values(regions.value).find(x => x.length > 0),
    rotation: rotation.value
  };
  downloadRawdata(param, isDownloading, downloadLink.value);
};

interface DataStructure {
  Species: {
    Terrestrial: string[];
    Wetland: string[];
  };
  Habitat: {
    Terrestrial: string[];
    Wetland: string[];
  };
}

// Create a computed property to transform the data
const restructuredData = computed(() => {
  const newData: DataStructure = {
    Species: {
      Terrestrial: [],
      Wetland: []
    },
    Habitat: {
      Terrestrial: [],
      Wetland: []
    }
  };

  for (const data of Object.entries(dataCategoryOptions)) {
    // console.log(data[1].Species);
    for (const item of data[1].Species.detail) {
      if (data[0] === 'Wetland' && item.checked) {
        newData.Species.Wetland.push(item.name);
      }
      if (data[0] === 'Terrestrial' && item.checked) {
        newData.Species.Terrestrial.push(item.name);
      }
    }
    for (const item of data[1].Habitat.detail) {
      if (data[0] === 'Wetland' && item.checked) {
        newData.Habitat.Wetland.push(item.name);
      }
      if (data[0] === 'Terrestrial' && item.checked) {
        newData.Habitat.Terrestrial.push(item.name);
      }
    }
  }

  return newData;
});
// const downloadStream = async (param:RawdataDownloadParamType) => {
//   isDownloading.value = true;
//   const data = await getRawdataFile(param);
//   const blob = new Blob([data], { type: 'application/zip' });
//   const objectUrl = URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = objectUrl;
//   link.download = 'SpeciesRawDownload.zip';
//   document.body.appendChild(link); // for firefox if link not added into body, click won't work
//   link.click();
//   link.remove(); // remove the link after clicking. only needed for firefox
//   isDownloading.value = false;
// };

</script>
<style scoped>
@import 'rawdata.scss';
.text-right {
  text-align: right;
}
</style>
